const NoDataFound = (props) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    enableBackground="new 0 0 512 512"
    xmlSpace="preserve"
    width={400}
    height={400}
    {...props}
  >
    <g>
      <path
        fill="#EDEDED"
        d="M387.9,106.7v24.1H151.3c0,0-15.7,2.4-15.7-15.7V70.5c0,0-2.4-12.7,12.7-12.7h75.4l19.3,32h130.4   C373.4,89.8,387.9,92.2,387.9,106.7z"
      />
      <g>
        <path
          fill="#51597D"
          d="M127.8,295.1c-2.6,0-7.1-0.5-10.8-3.7c-3.7-3.2-5.5-8-5.5-14.5V87.6c-0.2-1.2-0.7-6.4,2.7-10.5    c2.6-3.2,6.8-4.8,12.4-4.8H202c0.8,0,1.6,0.4,2.1,1.2l18.6,30.8h129c0.1,0,0.3,0,0.4,0c5.7,1,16.5,6.2,16.5,19.3v169    c0,1.3-1.1,2.4-2.4,2.4H129.7C129.4,295.1,128.7,295.1,127.8,295.1z M126.6,77.2c-4.1,0-7,1-8.7,3c-2.3,2.8-1.6,6.8-1.6,6.8    c0,0.1,0,0.3,0,0.4v189.5c0,5,1.3,8.7,3.9,10.9c3.7,3.2,9,2.4,9,2.4c0.1,0,0.2,0,0.4,0h234.2V123.6c0-11.6-10.7-14.2-12.3-14.5    H221.3c-0.8,0-1.6-0.4-2.1-1.2l-18.6-30.8H126.6z"
        />
      </g>
      <ellipse fill="#F5F5F5" cx={320.9} cy={431.1} rx={166.1} ry={32.1} />
      <g>
        <line fill="#FFFFFF" x1={395.1} y1={360.2} x2={402.4} y2={367.4} />
        <path
          fill="#51597D"
          d="M402.3,369.8c-0.6,0-1.2-0.2-1.7-0.7l-7.2-7.2c-0.9-0.9-0.9-2.5,0-3.4c0.9-0.9,2.5-0.9,3.4,0l7.2,7.2    c0.9,0.9,0.9,2.5,0,3.4C403.6,369.6,403,369.8,402.3,369.8z"
        />
      </g>
      <g>
        <line fill="#FFFFFF" x1={407.2} y1={350.5} x2={414.4} y2={357.8} />
        <path
          fill="#51597D"
          d="M414.4,360.2c-0.6,0-1.2-0.2-1.7-0.7l-7.2-7.2c-0.9-0.9-0.9-2.5,0-3.4c0.9-0.9,2.5-0.9,3.4,0l7.2,7.2    c0.9,0.9,0.9,2.5,0,3.4C415.7,360,415,360.2,414.4,360.2z"
        />
      </g>
      <circle fill="#EDEDED" cx={334.8} cy={273.3} r={108.6} />
      <g>
        <circle fill="#FFFFFF" cx={317.9} cy={273.3} r={108.6} />
        <path
          fill="#51597D"
          d="M317.9,384.3c-61.2,0-111-49.8-111-111s49.8-111,111-111s111,49.8,111,111S379.1,384.3,317.9,384.3z     M317.9,167.1c-58.6,0-106.2,47.6-106.2,106.2s47.6,106.2,106.2,106.2s106.2-47.6,106.2-106.2S376.4,167.1,317.9,167.1z"
        />
      </g>
      <g>
        <path
          fill="#51597D"
          d="M317.9,367.4c-51.9,0-94.1-42.2-94.1-94.1s42.2-94.1,94.1-94.1s94.1,42.2,94.1,94.1    S369.8,367.4,317.9,367.4z M317.9,184c-49.2,0-89.3,40.1-89.3,89.3c0,49.3,40.1,89.3,89.3,89.3c49.3,0,89.3-40.1,89.3-89.3    C407.2,224,367.1,184,317.9,184z"
        />
      </g>
      <g>
        <path
          fill="#51597D"
          d="M500.9,252.4c-6.1,0-11.1-5-11.1-11.1s5-11.1,11.1-11.1c6.1,0,11.1,5,11.1,11.1S507,252.4,500.9,252.4z     M500.9,233.1c-4.5,0-8.2,3.7-8.2,8.2c0,4.5,3.7,8.2,8.2,8.2c4.5,0,8.2-3.7,8.2-8.2C509.1,236.8,505.4,233.1,500.9,233.1z"
        />
      </g>
      <circle fill="#EDEDED" cx={500.9} cy={241.3} r={4.8} />
      <g>
        <path
          fill="#51597D"
          d="M366.1,148.2H115.3c-1.3,0-2.5-0.9-2.6-2.2c-0.1-1.4,1-2.6,2.4-2.6h251c1.1,0,2.2,0.7,2.4,1.8    C368.9,146.7,367.7,148.2,366.1,148.2z"
        />
      </g>
      <g>
        <g>
          <path
            fill="#51597D"
            d="M23.4,101.9c-1.3,0-2.4-1.1-2.4-2.4v-29c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4v29     C25.8,100.8,24.7,101.9,23.4,101.9z"
          />
        </g>
        <g>
          <path
            fill="#51597D"
            d="M37.8,87.4h-29c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4h29c1.3,0,2.4,1.1,2.4,2.4S39.2,87.4,37.8,87.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#51597D"
            d="M269,264.2c-0.6,0-1.2-0.2-1.7-0.7c-0.9-0.9-0.9-2.5,0-3.4l20.5-20.5c0.9-0.9,2.5-0.9,3.4,0     c0.9,0.9,0.9,2.5,0,3.4l-20.5,20.5C270.2,264,269.6,264.2,269,264.2z"
          />
        </g>
        <g>
          <path
            fill="#51597D"
            d="M289.5,264.2c-0.6,0-1.2-0.2-1.7-0.7L267.3,243c-0.9-0.9-0.9-2.5,0-3.4c0.9-0.9,2.5-0.9,3.4,0l20.5,20.5     c0.9,0.9,0.9,2.5,0,3.4C290.7,264,290.1,264.2,289.5,264.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#51597D"
            d="M348.7,264.2c-0.6,0-1.2-0.2-1.7-0.7c-0.9-0.9-0.9-2.5,0-3.4l20.5-20.5c0.9-0.9,2.5-0.9,3.4,0     c0.9,0.9,0.9,2.5,0,3.4l-20.5,20.5C349.9,264,349.3,264.2,348.7,264.2z"
          />
        </g>
        <g>
          <path
            fill="#51597D"
            d="M369.1,264.2c-0.6,0-1.2-0.2-1.7-0.7L347,243c-0.9-0.9-0.9-2.5,0-3.4c0.9-0.9,2.5-0.9,3.4,0l20.5,20.5     c0.9,0.9,0.9,2.5,0,3.4C370.4,264,369.8,264.2,369.1,264.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#51597D"
            d="M467.5,97.1c-1.3,0-2.4-1.1-2.4-2.4V51.2c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4v43.5     C469.9,96,468.9,97.1,467.5,97.1z"
          />
        </g>
        <g>
          <path
            fill="#51597D"
            d="M489.3,75.3h-43.5c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4h43.5c1.3,0,2.4,1.1,2.4,2.4     S490.6,75.3,489.3,75.3z"
          />
        </g>
      </g>
      <g>
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeMiterlimit={10}
          d="M301,309.5c0,0,2.4-14.5,19.3-14.5c0,0,19.3,0,19.3,14.5"
        />
        <path
          fill="#51597D"
          d="M303.6,309l-0.1,0c-1.5,0.1-2.7-1.4-2.3-2.9c1.3-4.8,5.7-13.5,20.1-13.5c7,0,17,2.2,19.3,14.2    c0.3,1.4-0.8,2.7-2.2,2.7h-0.1c-1.1,0-2.1-0.8-2.2-1.9c-1.4-10-14.1-10.1-14.8-10.1c-11.5,0-14.7,6.7-15.6,9.9    C305.4,308.2,304.6,308.9,303.6,309z"
        />
      </g>
      <g>
        <path
          fill="#FFFFFF"
          d="M477.9,431.1L477.9,431.1c-7.7,7.7-20.1,7.7-27.8,0l-41.3-41.3c-7.7-7.7-7.7-20.1,0-27.8l0,0    c7.7-7.7,20.1-7.7,27.8,0l41.3,41.3C485.6,411,485.6,423.4,477.9,431.1z"
        />
        <path
          fill="#51597D"
          d="M464,439.2c-5.6,0-11.3-2.1-15.6-6.4l-41.3-41.3c-4.2-4.2-6.5-9.7-6.5-15.6s2.3-11.4,6.5-15.6    c8.6-8.6,22.6-8.6,31.2,0l41.3,41.3c4.2,4.2,6.5,9.7,6.5,15.6s-2.3,11.4-6.5,15.6l0,0C475.3,437.1,469.7,439.2,464,439.2z     M422.7,358.7c-4.4,0-8.8,1.7-12.2,5c-3.3,3.3-5,7.6-5,12.2c0,4.6,1.8,8.9,5,12.2l41.3,41.3c6.7,6.7,17.6,6.7,24.3,0l0,0    c3.3-3.3,5-7.6,5-12.2c0-4.6-1.8-8.9-5-12.2l-41.3-41.3C431.6,360.4,427.1,358.7,422.7,358.7z M477.9,431.1L477.9,431.1    L477.9,431.1z"
        />
      </g>
      <path
        fill="#EDEDED"
        d="M0.6,298.3L33,359.7c1.4,2.7,4.7,3.8,7.3,2.3l45.5-24.4c2.6-1.4,3.6-4.7,2.1-7.4l-36.2-65.3L2.8,291   C0.2,292.4-0.8,295.7,0.6,298.3z"
      />
      <g>
        <path
          fill="#51597D"
          d="M51,355c-0.7,0-1.4-0.1-2.1-0.3c-1.8-0.6-3.4-1.8-4.2-3.5l-30-57.8l0,0c-1.8-3.5-0.5-7.8,3-9.6l37-19.8    c0.4-0.2,0.9-0.3,1.3-0.1l18.2,5.1c0.5,0.1,0.9,0.4,1.1,0.9l27.6,50.3c0.9,1.7,1.1,3.6,0.6,5.5c-0.5,1.9-1.8,3.4-3.5,4.3    l-45.5,24.4C53.3,354.7,52.2,355,51,355z M17.8,291.6l30,57.8c0.4,0.8,1.2,1.5,2.1,1.8c0.9,0.3,1.9,0.2,2.7-0.3l45.5-24.4    c0.8-0.5,1.5-1.2,1.7-2.1c0.3-0.9,0.2-1.9-0.3-2.7l-27.2-49.6l-16.8-4.7l-36.3,19.4C17.6,287.8,17,289.9,17.8,291.6L17.8,291.6z"
        />
      </g>
      <g>
        <path
          fill="#51597D"
          d="M62.4,280.4c-0.2,0-0.4,0-0.5-0.1c-0.5-0.1-0.8-0.5-1.1-0.9l-7-13.1c-0.3-0.7-0.3-1.5,0.2-2    c0.5-0.6,1.3-0.8,2-0.5l19.1,6.5c0.7,0.2,1.2,0.8,1.2,1.6c0.1,0.7-0.3,1.4-0.9,1.7l-12.1,6.5C63,280.3,62.7,280.4,62.4,280.4z     M59.2,268.7l4,7.4l6.9-3.7L59.2,268.7z"
        />
      </g>
      <g>
        <path
          fill="#51597D"
          d="M31.1,302.5c-0.7,0-1.3-0.4-1.6-1c-0.5-0.9-0.1-2,0.8-2.4l24.3-12.4c0.9-0.4,2-0.1,2.4,0.8    c0.5,0.9,0.1,2-0.8,2.4L32,302.3C31.7,302.4,31.4,302.5,31.1,302.5z"
        />
      </g>
      <g>
        <path
          fill="#51597D"
          d="M43.2,325.1c-0.7,0-1.3-0.4-1.6-1c-0.5-0.9-0.1-2,0.8-2.4l29.8-15.2c0.9-0.5,2-0.1,2.4,0.8    c0.5,0.9,0.1,2-0.8,2.4l-29.8,15.2C43.8,325,43.5,325.1,43.2,325.1z"
        />
      </g>
      <g>
        <path
          fill="#51597D"
          d="M49,335.9c-0.7,0-1.3-0.4-1.6-1c-0.5-0.9-0.1-2,0.8-2.4l31.2-15.9c0.9-0.4,2-0.1,2.4,0.8    c0.5,0.9,0.1,2-0.8,2.4l-31.2,15.9C49.5,335.8,49.3,335.9,49,335.9z"
        />
      </g>
      <g>
        <path
          fill="#51597D"
          d="M36.4,313.8c-0.7,0-1.3-0.4-1.6-1c-0.5-0.9-0.1-2,0.8-2.4l29.8-15.2c0.9-0.5,2-0.1,2.4,0.8    c0.5,0.9,0.1,2-0.8,2.4l-29.8,15.2C37,313.8,36.7,313.8,36.4,313.8z"
        />
      </g>
    </g>
  </svg>
);
export default NoDataFound;
